import { gql } from "@apollo/client";
import { GeoType } from "./GeoType";
import { SiteType } from "./SiteType";

export interface WarehouseType {
    id?: number;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    contactName?: string;
    state?: string;
    country?: string;
    countryCode?: number;
    deliveryZoneZipcodeList?: string[];
    pickupZoneZipcodeList?: string[];
    pickupDeadlineTime?: string;
    appointmentDeadlineTime?: string;
    extension?: string;
    location?: GeoType;
    name?: string;
    parentSiteId?: number;
    phoneNumber?: string;
    siteType?: SiteType;
    sortingCode?: string;
    timezone?: string;
    timezoneLocation?: string;
    zipcode?: string;
    /** @deprecated 大包批量入库开关已改为渠道维度（clientCartonBatchInboundChannelsJson），保留仅为兼容 */
    isClientCartonBatchInboundEnabled?: boolean;
    /** 该 hub 启用大包批量入库的渠道 ID JSON 数组（如 "[109,224]"）；null/空 = 全部逐票 */
    clientCartonBatchInboundChannelsJson?: string | null;
    businessType?: number;
};

export const WAREHOUSE_FIELDS = gql`
    fragment WarehouseFields on WarehouseType {
        id
        parentSiteId
        name
        siteType
        addressLine1
        addressLine2
        city
        contactName
        state
        country
        countryCode
        deliveryZoneZipcodeList
        pickupZoneZipcodeList
        pickupDeadlineTime
        appointmentDeadlineTime
        extension
        location {
            latitude
            longitude
        }
        phoneNumber
        sortingCode
        timezone
        timezoneLocation
        zipcode
        isClientCartonBatchInboundEnabled
        clientCartonBatchInboundChannelsJson
        businessType
    }
`;